// external imports
import React, { useState, useEffect, useContext } from 'react';
import { Tooltip } from 'react-tooltip';

// local imports
import exportConfig from '../../config';
import earthiLogo from '../../images/earthi-rev2.svg';
import packageJson from '../../../package.json';
import { getAuthenticatedUserAttributes } from '../../actions/authUtils';
import Logout from '../auth/Logout';
import Navlink from './Navlink';

// custom hooks & context
import { pipelineContext } from '../../contexts/pipelineContext';

// css packages
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default function Sidenav(props) {
	const [userAttributes, setUserAttributes] = useState({});
	const pipelineContextSideNav = useContext(pipelineContext);
	const [sideNavIsOpen, setSideNavOpen] = useState(true);

	const toggle = () => setSideNavOpen(!sideNavIsOpen);

	useEffect(() => {
		const getUserAttributes = async () => {
			const userAttributesAuth = await getAuthenticatedUserAttributes();

			setUserAttributes({
				givenName: userAttributesAuth.givenName,
				familyName: userAttributesAuth.familyName,
				email: userAttributesAuth.email,
				initials: userAttributesAuth.initials
			});
		};

		getUserAttributes().catch(console.error);
	}, []);

	const openAndCloseNav = () => {
		var x = document.getElementById('myLinks');
		var y = document.getElementById('myLinks2');

		if (x.style.display === 'block') {
			x.style.display = 'none';
			y.style.display = 'none';
		} else {
			x.style.display = 'block';
			//y.style.display = 'block';
		}
	};

	useEffect(() => {
		const mediaQuery = window.matchMedia('(min-width: 768px)');
		var x = document.getElementById('myLinks');
		var y = document.getElementById('myLinks2');
		var z = document.getElementById('sideNavLinks3');

		const handleScreenChange = (e) => {
			if (e.matches) {
				x.style.display = 'block';
				y.style.display = 'block';
				z.style.display = 'none';
			} else {
				x.style.display = 'none';
				y.style.display = 'none';
				z.style.display = 'block';
			}
		};

		handleScreenChange(mediaQuery);
		mediaQuery.addEventListener('change', handleScreenChange);

		return () => {
			mediaQuery.removeEventListener('change', handleScreenChange);
		};
	}, []);

	const NAVLINK_PROPS = {
		navIsOpen: sideNavIsOpen,
		userQCing: pipelineContextSideNav.capsInPipeline.length > 0 ? true : false,
		userUploading: pipelineContextSideNav.straightToUpload,
		setUserUploading: pipelineContextSideNav.setStraightToUpload
	};

	return (
		<div
			style={{
				width: sideNavIsOpen ? '220px' : '70px',
				transition: 'width 0.4s ease',
				overflow: 'hidden',
				whiteSpace: 'nowrap',
				backgroundColor: '#332d2d',
				//border: '1px solid #ccc',
				padding: sideNavIsOpen ? '1rem' : '5px'
			}}
		>
			<div className="topnav">
				<div
					className="d-flex align-items-center my-2 mb-md-0 p-md-2 me-md-auto text-white text-decoration-none"
					style={{ height: '50px' }}
				>
					<img
						style={{ display: sideNavIsOpen ? 'block' : 'none' }}
						src={earthiLogo}
						alt=""
						width="39"
						height="39"
						className="rounded-circle ms-1 me-3"
					></img>
					<span
						className="fs-4"
						style={{ display: sideNavIsOpen ? 'block' : 'none' }}
					>
						QC
					</span>

					<button
						onClick={toggle}
						title={
							sideNavIsOpen
								? 'Minimise navigation bar'
								: 'Maximise navigation bar'
						}
						className={
							sideNavIsOpen
								? 'noStyleButton ms-5 sideNavChevron'
								: 'noStyleButton ms-3 sideNavChevron'
						}
					>
						<i
							className={
								sideNavIsOpen
									? 'fa-solid fa-chevron-left'
									: 'fa-solid fa-chevron-right'
							}
						></i>
					</button>
				</div>

				<hr className="sidenav-hr"></hr>

				<div id="myLinks">
					<Navlink
						path={'/'}
						icon={'fa-solid fa-house pe-2'}
						text={'Homepage'}
						navlinkProps={NAVLINK_PROPS}
					/>
					<Navlink
						path={'/qc'}
						icon={'fa fa-solid fa-calendar-day pe-3'}
						text={'QC'}
						navlinkProps={NAVLINK_PROPS}
					/>

					<Navlink
						path={'/users_captures'}
						icon={'fa fa-solid fa-user-tag pe-3'}
						text={`My captures`}
						navlinkProps={NAVLINK_PROPS}
					/>

					<Navlink
						path={'/users'}
						icon={'fa fa-solid fa-users pe-3'}
						text={'QC Users'}
						navlinkProps={NAVLINK_PROPS}
					/>

					<Navlink
						path={'/captures'}
						icon={'fa fa-solid fa-images pe-3'}
						text={'All captures'}
						navlinkProps={NAVLINK_PROPS}
					/>

					<Navlink
						path={'/reports'}
						icon={'fa fa-solid fa-images pe-3'}
						text={'Reports'}
						navlinkProps={NAVLINK_PROPS}
					/>

					<Navlink
						path={'/scripts'}
						icon={'fa fa-solid fa-list-check pe-3'}
						text={'QC data checks'}
						navlinkProps={NAVLINK_PROPS}
					/>
					<Navlink
						path={'/exports'}
						icon={'fa-solid fa-file-export pe-3'}
						text={'Data exports'}
						navlinkProps={NAVLINK_PROPS}
					/>

					<Navlink
						path={'/admin'}
						icon={'fa-solid fa-comments me-2'}
						text={'Comments manager'}
						navlinkProps={NAVLINK_PROPS}
					/>

					<div id="sideNavLinks3">
						<hr style={{ width: '100%', color: 'white' }}></hr>
						<div
							className="row mt-1 "
							style={{ display: sideNavIsOpen ? 'flex' : 'none' }}
						>
							<div className="col d-flex justify-content-center align-items-center">
								<div className="form-check form-switch align-items-center px-0">
									<label
										data-tooltip-id="notificationsOnTT"
										className="form-check-label"
										htmlFor="toggleAutoQCColourCodeToggle"
										style={{ color: 'white' }}
									>
										{pipelineContextSideNav.notificationsEnabled ? (
											<i
												className="fa-solid fa-bell"
												style={{ color: 'white' }}
												data
											></i>
										) : (
											<i
												className="fa-solid fa-bell-slash"
												style={{ color: 'white' }}
											></i>
										)}
									</label>
									<input
										className="form-check-input px-0"
										style={{ display: 'none', width: '0px' }}
										type="checkbox"
										role="switch"
										id="toggleAutoQCColourCodeToggle"
										checked={pipelineContextSideNav.notificationsEnabled}
										onChange={(e) =>
											pipelineContextSideNav.setNotificationsEnabled(
												(prevState) => !prevState
											)
										}
									/>
									<Tooltip id="notificationsOnTT" place="top" effect="solid">
										{pipelineContextSideNav.notificationsEnabled ? (
											<>Notifications (ON)</>
										) : (
											<>Notifications (OFF)</>
										)}
									</Tooltip>
								</div>
							</div>
							<div className="col d-flex justify-content-center align-items-center">
								<i class="fa-solid fa-gear" style={{ color: 'white' }}></i>
							</div>
							<div className="col d-flex justify-content-center align-items-center">
								<i
									class="fa-solid fa-circle-info"
									style={{ color: 'white' }}
								></i>
							</div>
						</div>

						<p
							className="my-2 py-0 text-center text-primary fw-bold"
							style={{ position: 'relative', bottom: '0' }}
							data-tooltip-id="environment"
						>
							{' '}
							{exportConfig.gainsEnvironment.toUpperCase()}
						</p>

						<div
							className="dropdown px-2"
							style={{
								backgroundColor: '#332d2d'
							}}
						>
							<div class="dropdown d-flex justify-content-center">
								<button
									className="dropdown-toggle mb-1"
									style={{
										backgroundColor: '#332d2d',
										color: 'white',
										fontSize: '20px',
										border: 'none'
									}}
									type="button"
									id="dropdownMenuButton1"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									<strong className="px-1 fs-5" title={userAttributes.email}>
										{userAttributes.initials}
									</strong>
								</button>
								<ul
									className="dropdown-menu bg-dark"
									aria-labelledby="dropdownMenuButton1"
									style={{ zIndex: '9999' }}
								>
									<li className="dropdown-item bg-dark text-white">
										{' '}
										{userAttributes.givenName} {userAttributes.familyName}
									</li>
									<li className="dropdown-item bg-dark text-white">
										{userAttributes.email}
									</li>
									<li className="dropdown-item bg-dark text-white">
										App version: {packageJson.version}
									</li>
									<li>
										<hr className="dropdown-divider"></hr>
									</li>
									{!pipelineContextSideNav.qcInProgress && (
										<li className="dropdown-item bg-dark text-white">
											<Logout props={props} />
										</li>
									)}
								</ul>
							</div>
						</div>
					</div>
				</div>

				{/* bottom section */}
				<div
					id="myLinks2"
					style={{
						position: 'fixed',
						bottom: '0',
						left: '0',
						width: sideNavIsOpen ? '200px' : '50px',
						marginLeft: sideNavIsOpen ? '0px' : '10px'
					}}
				>
					<hr style={{ border: '2px solid white', margin: '5px' }}></hr>

					<div
						className="row mt-1"
						style={{ display: sideNavIsOpen ? 'flex' : 'none' }}
					>
						<div className="col d-flex justify-content-center align-items-center">
							<div className="form-check form-switch align-items-center px-0">
								<label
									data-tooltip-id="notificationsOnTT"
									className="form-check-label"
									htmlFor="toggleAutoQCColourCodeToggle"
									style={{ color: 'white' }}
								>
									{pipelineContextSideNav.notificationsEnabled ? (
										<i
											className="fa-solid fa-bell"
											style={{ color: 'white' }}
											data
										></i>
									) : (
										<i
											className="fa-solid fa-bell-slash"
											style={{ color: 'white' }}
										></i>
									)}
								</label>
								<input
									className="form-check-input px-0"
									style={{ display: 'none', width: '0px' }}
									type="checkbox"
									role="switch"
									id="toggleAutoQCColourCodeToggle"
									checked={pipelineContextSideNav.notificationsEnabled}
									onChange={(e) =>
										pipelineContextSideNav.setNotificationsEnabled(
											(prevState) => !prevState
										)
									}
								/>
								<Tooltip id="notificationsOnTT" place="top" effect="solid">
									{pipelineContextSideNav.notificationsEnabled ? (
										<>Notifications (ON)</>
									) : (
										<>Notifications (OFF)</>
									)}
								</Tooltip>
							</div>
						</div>
						<div className="col d-flex justify-content-center align-items-center">
							<i class="fa-solid fa-gear" style={{ color: 'white' }}></i>
						</div>
						<div className="col d-flex justify-content-center align-items-center">
							<i class="fa-solid fa-circle-info" style={{ color: 'white' }}></i>
						</div>
					</div>

					<p
						className="my-2 py-0 text-center text-primary fw-bold"
						style={{ position: 'relative', bottom: '0' }}
						data-tooltip-id="environment"
					>
						{' '}
						{exportConfig.gainsEnvironment.toUpperCase()}
					</p>

					<div
						className="dropdown px-2"
						style={{
							backgroundColor: '#332d2d'
						}}
					>
						<div class="dropdown d-flex justify-content-center">
							<button
								className="dropdown-toggle mb-1"
								style={{
									backgroundColor: '#332d2d',
									color: 'white',
									fontSize: '20px',
									border: '#332d2d solid 1px'
								}}
								type="button"
								id="dropdownMenuButton1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<strong className="px-1 fs-5" title={userAttributes.email}>
									{userAttributes.initials}
								</strong>
							</button>

							<ul
								className="dropdown-menu bg-dark"
								aria-labelledby="dropdownMenuButton1"
								style={{ zIndex: '99999', }}
							>
								<li className="dropdown-item bg-dark text-white">
									{' '}
									{userAttributes.givenName} {userAttributes.familyName}
								</li>
								<li className="dropdown-item bg-dark text-white">
									{userAttributes.email}
								</li>
								<li className="dropdown-item bg-dark text-white">
									App version: {packageJson.version}
								</li>
								<li>
									<hr className="dropdown-divider"></hr>
								</li>
								{!pipelineContextSideNav.qcInProgress && (
									<li className="dropdown-item bg-dark text-white">
										<Logout props={props} />
									</li>
								)}
							</ul>
						</div>
					</div>
				</div>

				<Tooltip id="logout-disabled" place="bottom" effect="solid">
					Please exit QC before attempting to log out
				</Tooltip>
			</div>

			<a
				href="javascript:void(0);"
				className="close-sidenav-icon"
				onClick={(e) => openAndCloseNav()}
			>
				<i className="fa fa-bars"></i>
			</a>
		</div>
	);
}
